module.exports = "<div *ngIf=\"!valid\">\n  <p class=\"form-control-feedback\">{{getValidationMessage(error)}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/validation-message/validation-message.component.html
// module id = wvGA
// module chunks = 0